import { Typography, withStyles, withTheme } from 'material-ui';
import React, { Component } from 'react';
import ResourceIndexGrid from '../components/ResourceIndexGrid';
import SubHeader from '../components/SubHeader';
import AppBarSpacing from '../utils/AppBarSpacing';

class Index extends Component {
  render() {
    var info = this.props.resources[this.props.resourceID];
    return (
      <React.Fragment>
        <SubHeader className={this.props.classes['top-app_bar_spacing-1']}>
          <Typography variant="title" color='inherit' style={{flexGrow: 1}}>
            {info.name}
          </Typography>
        </SubHeader>
        <main>
          <ResourceIndexGrid resources={this.props.resources} indexed={info.indexed} gridContainerProps={{className: this.props.classes["margin-app_bar_spacing-2"]}}/>
        </main>
      </React.Fragment>
    );
  }
}

export default withTheme()(withStyles(AppBarSpacing)(Index));


// WEBPACK FOOTER //
// ./src/resource_views/Index.js